import Api from '@/api'
import { saveAs } from 'file-saver'

const api = new Api()
const apiSpec = api
  .sales()
  .bid()
  .spec()

export default {
  async fetchAll({ commit }, { bidNumber, ...queryParams }) {
    try {
      const { data } = await apiSpec.sites(bidNumber).fetchAll(queryParams)
      const site = data.data.sites

      commit('setSites', site.models)

      return site
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async exportSites({ commit }, bidNumber) {
    try {
      const { data } = await apiSpec.export(bidNumber)
      const sites = data.data

      saveAs(new Blob([JSON.stringify({ data: sites })]), `${bidNumber}.json`)

      return sites
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async importSites({ commit }, payload) {
    try {
      const { bidNumber, date, sites } = payload
      const { data } = await apiSpec.import(bidNumber, date, sites)
      return data.data
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async resetArmsAndAnalysis({ commit }, payload) {
    try {
      const { bidNumber, siteId } = payload
      const { data } = await apiSpec.sites(bidNumber).resetArmsAndAnalysis(siteId)

      commit('Bid/resetArms', undefined, { root: true })
      commit('Bid/Analysis/removeAnalysis', null, { root: true })

      return data.data
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
